import{jsx as t}from"react/jsx-runtime";import{generateUUID as e}from"@vds-core/utilities";import{Component as i}from"react";import o,{css as n}from"styled-components";import{ColorTokens as r}from"@vds-tokens/color";import{LayoutTokens as s}from"@vds-tokens/layout";const a=96,l=o.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-1d529mz-0"})`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
`,u=o.div.withConfig({displayName:"Track",componentId:"VDS__sc-1d529mz-1"})`
  -webkit-user-select: none; // Disable magnifier on iOS
  -webkit-touch-callout: none;
  -webkit-user-callout: none;
  -webkit-user-drag: none;
  -webkit-user-modify: none;
  -webkit-highlight: none;
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  position: relative;
  width: ${a}px;
  height: ${function({$hovered:t}){return t?s.space["2X"].value:s.space["1X"].value}};
  transition:
    height 100ms linear,
    width 100ms linear,
    border-radius 100ms linear;
  box-sizing: border-box;
  border-radius: ${s.space["1X"].value};
  background-color: ${function({surface:t}){return r.interactive.scrolltrack[`on${t}`].value}};

  &::before {
    min-height: 44px;
    min-width: 44px;
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  }
  ${function({surface:t,$percentageLeft:e,$percentageRight:i,$sideClicked:o,$scrubberWidth:s,$dragging:a}){return!a&&n`
      &:active:not(:focus):not(:focus-within) {
        :after {
          postition: absolute;
          border-radius: 12px;
          content: '';
          height: 100%;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          opacity: 15%;
          background: -webkit-linear-gradient(
            to ${"right"===o?"left":"right"},
            ${"light"===t?r.palette.black.value:r.palette.white.value}
              calc(
                ${"left"===o?e:i}% +
                  ${s-5}px
              ),
            ${"light"===t?r.palette.gray85.value:r.palette.gray20.value}
              calc(
                ${"left"===o?e:i}% +
                  ${s-5}px
              )
          );
          background: linear-gradient(
            to ${"right"===o?"left":"right"},
            ${"light"===t?r.palette.black.value:r.palette.white.value}
              calc(
                ${"left"===o?e:i}% +
                  ${s-5}px
              ),
            ${"light"===t?r.palette.gray85.value:r.palette.gray20.value}
              calc(
                ${"left"===o?e:i}% +
                  ${s-5}px
              )
          );
        }
      }
    `}}
`,h=o.div.withConfig({displayName:"Thumb",componentId:"VDS__sc-1d529mz-2"})`
  touch-action: manipulation;
  -webkit-user-select: none; // Disable magnifier on iOS
  -webkit-touch-callout: none;
  -webkit-user-callout: none;
  -webkit-user-drag: none;
  -webkit-user-modify: none;
  -webkit-highlight: none;
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  position: absolute;
  will-change: transform;
  ${function({$enableThumbAnimation:t}){return t?n`
          -webkit-transition:
            height 100ms linear,
            left 100ms linear;
          -moz-transition:
            height 100ms linear,
            left 100ms linear;
          -o-transition:
            height 100ms linear,
            left 100ms linear;
          transition:
            height 100ms linear,
            left 100ms linear;
        `:n`
          -webkit-transition:
            height 100ms linear,
            left 0ms linear;
          -moz-transition:
            height 100ms linear,
            left 0ms linear;
          -o-transition:
            height 100ms linear,
            left 0ms linear;
          transition:
            height 100ms linear,
            left 0ms linear;
        `}}
  left: ${function({left:t}){return t}}px;
  border-radius: ${s.space["1X"].value};
  height: ${function({$hovered:t}){return t?s.space["2X"].value:s.space["1X"].value}};
  min-width: ${function({$hovered:t}){return t?s.space["5X"].value:s.space["4X"].value}};
  width: ${function({$scrubberWidth:t}){return t}}px;
  outline: none;
  background-color: ${function({surface:t}){return r.interactive.scrollthumb[`on${t}`].value}};
  z-index: 1;

  /** HIT AREA **/
  &::before {
    min-height: 44px;
    min-width: 44px;
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  }
`,c=function(t){return t.targetTouches&&t.targetTouches[0]?t.targetTouches[0].clientX:t.clientX};class d extends i{constructor(t){var i;super(t),i=this,this._onThumbMouseUp=function(t){var e;const{onThumbMouseUp:o}=i.props;i.thumb&&i.thumb.blur(),t.stopPropagation(),o&&o(t),(null===(e=i.state.mouse)||void 0===e?void 0:e.clientX)&&i.setState({mouse:null,amountMouseMoved:null,scrolling:!1}),"undefined"!=typeof window&&window.removeEventListener("mousemove",i._onMouseMove,!0)},this._onThumbTouchEnd=function(t){var e;const{onThumbTouchEnd:o}=i.props;i.touchTimer&&clearTimeout(i.touchTimer),i.touchTimer=null,i.setState({hovered:!1,dragging:!1}),o&&o(t),(null===(e=i.state.mouse)||void 0===e?void 0:e.clientX)&&i.setState({mouse:null,amountMouseMoved:null,scrolling:!1}),"undefined"!=typeof window&&window.removeEventListener("touchmove",i._onMouseMove,!0)},this._onWindowMouseUp=function(t){i.thumb&&i.thumb.blur(),i._onThumbMouseUp(t)},this._onMouseMove=function(t){var e,o;const n=c(t),{amountMouseMoved:r,mouse:s}=i.state,{onScrubberDrag:l}=i.props,u=a-i.scrubberWidth,h=n-(null!==(e=null==s?void 0:s.clientX)&&void 0!==e?e:0);if(h===r)return;const d=(null!==(o=null==s?void 0:s.left)&&void 0!==o?o:0)+h;if(d<=0?i.setState({left:0,newMouseMoved:h}):d>=u?i.setState({left:u,amountMouseMoved:h}):i.setState({left:d,newMouseMoved:h}),l){l(d/(a-i.scrubberWidth))}},this._onThumbMouseDown=function(t){const{onThumbMouseDown:e}=i.props;i.thumb&&i.thumb.blur(),t.stopPropagation();const o=c(t);e&&e(t);const{left:n}=i.state;i.setState({mouse:{clientX:o,left:n},scrolling:!0}),"undefined"!=typeof window&&window.addEventListener("mousemove",i._onMouseMove,!0)},this._onThumbTouchStart=function(t){const{onThumbTouchStart:e}=i.props;i.setState({dragging:!0}),i.touchTimer=setTimeout((function(){i.setState({hovered:!0})}),100),e&&e(t);const o=c(t),{left:n}=i.state;i.setState({mouse:{clientX:o,left:n},scrolling:!0}),"undefined"!=typeof window&&window.addEventListener("touchmove",i._onMouseMove,!0)},this._onMoveForward=function(t){const{onMoveForward:e}=i.props;e&&e(t)},this._onMoveBackward=function(t){const{onMoveBackward:e}=i.props;e&&e(t)},this._onMouseDownTrack=function(t){var e,o;const{left:n}=i.state,r=null===(o=null===(e=t.target)||void 0===e?void 0:e.getBoundingClientRect())||void 0===o?void 0:o.left,s=c(t)-Math.round(r);void 0===n||s<1.4*n?i.setState({sideClicked:"left"}):i.setState({sideClicked:"right"})},this._onMouseUpTrack=function(t){const{sideClicked:e}=i.state;return"left"===e?i._onMoveBackward(t):i._onMoveForward(t)},this._setHovered=function(){return i.setState((function(t){return{hovered:!t.hovered}}))},this.state={sideClicked:null,hovered:null,dragging:!1,scrolling:!1,left:this.props.position||0},this._id=this.props.scrubberId?this.props.scrubberId:`${e()}`,this.thumbId=`${this._id}-thumb`,this.trackId=`${this._id}-track`}componentDidMount(){var t;const{layout:e,numberOfSlides:i}=this.props,{left:o}=this.state;this.thumb="undefined"!=typeof document&&document.getElementById(this.thumbId),this.scrubberWidth=a/parseInt(null==i?void 0:i.toString(),10)*parseInt(null!==(t=null==e?void 0:e.toString())&&void 0!==t?t:"",10),this.percentageLeft=o/a*100,this.percentageRight=100-this.percentageLeft-this.scrubberWidth,"undefined"!=typeof window&&(window.addEventListener("touchend",this._onThumbTouchEnd),window.addEventListener("mouseup",this._onWindowMouseUp)),this.maxScrollableWidth=a-this.scrubberWidth}componentDidUpdate(t,e){var i,o;const{layout:n,numberOfSlides:r,position:s}=this.props,{left:l,scrolling:u}=this.state;parseInt(t.layout,10)===parseInt(null!==(i=null==n?void 0:n.toString())&&void 0!==i?i:"",10)&&t.numberOfSlides===r||(this.scrubberWidth=a/parseInt(r.toString(),10)*parseInt(null!==(o=null==n?void 0:n.toString())&&void 0!==o?o:"",10),this.maxScrollableWidth=a-this.scrubberWidth),t.position!==s&&(null!=s?s:0)<=this.maxScrollableWidth&&!1===u&&this.setState({left:(null!=s?s:1)*this.maxScrollableWidth}),e.left!==l&&(this.percentageLeft=l/a*100,this.percentageRight=100-this.percentageLeft-this.scrubberWidth)}render(){const{left:e,hovered:i,sideClicked:o,dragging:n}=this.state,{surface:r,enableThumbAnimation:s,"data-track":a,"data-track-ignore":c,"data-analyticstrack":d,"data-clickstream":p,"data-sitecat-level":m,"data-sitecat-position":g,"data-sitecat-datatrack":b,"data-sitecat-cta":f}=this.props;return t(l,Object.assign({},!this.isTouchDevice&&{onMouseEnter:this._setHovered,onMouseLeave:this._setHovered},{children:t(u,{className:"scrollbar-track",id:this.trackId,$hovered:i,$scrubberWidth:this.scrubberWidth,$percentageRight:this.percentageRight,$percentageLeft:this.percentageLeft,$sideClicked:o,onMouseDown:this._onMouseDownTrack,onMouseUp:this._onMouseUpTrack,onTouchStart:this._onMouseDownTrack,onTouchEnd:this._onMouseUpTrack,surface:r,$dragging:n,children:t(h,{id:this.thumbId,onTouchStart:this._onThumbTouchStart,onTouchEnd:this._onThumbTouchEnd,onMouseDown:this._onThumbMouseDown,onMouseUp:this._onThumbMouseUp,$enableThumbAnimation:s,$hovered:i,surface:r,$scrubberWidth:this.scrubberWidth,left:e,"data-track":a,"data-track-ignore":c,"data-analyticstrack":d,"data-clickstream":p,"data-sitecat-level":m,"data-sitecat-position":g,"data-sitecat-datatrack":b,"data-sitecat-cta":f})})}))}}d.defaultProps={surface:"light",enableThumbAnimation:!1};export{d as default};
